import { combineReducers, configureStore } from '@reduxjs/toolkit';
import cemReducer from 'cui/components/auth/Slices/Cem.slice';
import snackbarReducer from 'cui/components/snackbar/Snackbar.slice';
import reportsReducer from 'pages/admin/reports/Reports.slice';
import workspacesReducer from 'pages/admin/workspaces/Workspaces.slice';
import usersReducer from 'pages/users/users.slice';
import breadcrumbReducer from '../../cui/components/breadcrumb/breadcrumb.slice';
import { persistReducer, persistStore } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import themeOptionsReducer from '../../store/themeOptionsSlice'
import { envProperties } from '../../utils/EnvironmentProperties';
import applicationsReducer from './applications.slice';

const isDevToolsEnabled = envProperties?.IsDevToolsEnabled;
const persistConfig = {
    key: 'root',
    storage: storageSession,
};

const combineReducer = combineReducers({
    applications: applicationsReducer,
    cem: cemReducer,
    reports: reportsReducer,
    snackbar: snackbarReducer,
    themeOptions: themeOptionsReducer,
    workspaces: workspacesReducer,
    users: usersReducer,
    breadcrumbs: breadcrumbReducer
});

const persistedReducer = persistReducer(persistConfig, combineReducer);

export const store = configureStore({
    devTools: isDevToolsEnabled ? Boolean(JSON.parse(envProperties.IsDevToolsEnabled)) : false,
    
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }),
    reducer: persistedReducer,
});

export const persistor = persistStore(store);
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
